<template>
<CModal @mtdclosemodal="mtdclosemodal" :show.sync="boo_modal" :close-on-backdrop="false" :centered="true" :title="title" :size="'md'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
    <div class="row">
        <div class="col-lg-12 col-md-12 mt-2 mb-2 ">
            <div class="input-group input-group-sm">
                <div class="input-group-text col-md-4">
                    <span style="border: none" class="input-group-text"><i class="fas fa-layer-group"></i></span>Proveedor
                </div>
                <input type="text" class="form-control form-control-sm" name="name" v-model="data_detail.name" placeholder="Nombre del proveedor" readonly/>
            </div>
        </div>
        <div class="col-lg-12 col-md-12 mt-2 mb-2 ">
            <div class="input-group input-group-sm">
                <div class="input-group-text col-md-4">
                    <span style="border: none" class="input-group-text"><i class="fas fa-layer-group"></i></span>RUC
                </div>
                <input type="text" class="form-control form-control-sm" name="ruc" v-model="data_detail.ruc" placeholder="RUC del proveedor" readonly/>
            </div>
        </div>
        <div class="col-lg-12 col-md-12 mt-2 mb-2 ">
            <div class="input-group input-group-sm">
                <div class="input-group-text col-md-4">
                    <span style="border: none" class="input-group-text"><i class="fas fa-layer-group"></i></span>Representante
                </div>
                <input type="text" class="form-control form-control-sm" name="vendor" v-model="data_detail.vendor" placeholder="Representante" readonly/>
            </div>
        </div>
        <div class="col-lg-12 col-md-12 mt-2 mb-2 ">
            <div class="input-group input-group-sm">
                <div class="input-group-text col-md-4">
                    <span style="border: none" class="input-group-text"><i class="fas fa-layer-group"></i></span>Celular
                </div>
                <input type="text" class="form-control form-control-sm" name="phone" v-model="data_detail.phone" placeholder="Celular" readonly/>
            </div>
        </div>
        <div class="col-lg-12 col-md-12 mt-2 mb-2 ">
            <div class="input-group input-group-sm">
                <div class="input-group-text col-md-4">
                    <span style="border: none" class="input-group-text"><i class="fas fa-layer-group"></i></span>Correo
                </div>
                <input type="text" class="form-control form-control-sm" name="email" v-model="data_detail.email" placeholder="Correo" readonly/>
            </div>
        </div>
    </div>
    <template #footer>
        <button class="btn btn-success btn-sm" @click="mtdSaveUserProvider" :disabled="cpDisabled">
            <i class="fas fa-user" />&nbsp; Crear Usuario
        </button>
    </template>
</CModal>
</template>
<SweetAlert :swal="swal" ref="SweetAlert" />

<script>
import CModal from "../../../shared/modals/CModal.vue";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";

import {
    mapActions
} from "vuex";

export default {
    name: "c-logistica-modals-ficha",
    components: {
        CModal,
        SweetAlert
    },
    data() {
        return {
            modalFicha: {
                title: '',
                modal_form: false
            },
            data_detail: {
                role_id: '',
                documento: "RUC",
                ruc: "",
                name: "",
                email: "",
                phone: "",
                vendor: "",
            },
            swal: "",
            selectPage: 1,
            stepPagination: [],
        };
    },
    props: {
        title: String,
        boo_modal: Boolean,
        payload: {
            type: Object,
            default: null
        },
    },
    watch: {
        payload: {
            handler(newVal) {
                if (newVal) {
                    this.data_detail = {
                        ...newVal
                    };
                }
            },
            immediate: true,
        },
    },
    computed: {
        cpDisabled() {
            return !(this.data_detail.name != '' && this.data_detail.ruc != '' && this.data_detail.phone != '' && this.data_detail.email != '');
        }
    },
    methods: {
        ...mapActions(["get", "post"]),
        filterKey: function (e) {
            let b = false;
            b = /^[0-9]+$/.test(e.key);
            if (b == false && e.key != "Backspace") {
                e.preventDefault();
            }
        },
        mtdclosemodal(opt) {
            this.data_detail.role_id = '';
            this.data_detail.documento = '';
            this.data_detail.ruc = '';
            this.data_detail.name = '';
            this.data_detail.email = '';
            this.data_detail.phone = '';
            this.data_detail.vendor = '';
            this.$emit('closeModalProvider',opt);
        },
        mtdSaveUserProvider: function () {
            this.$emit('UserProvider',this.data_detail, 0);
            this.mtdclosemodal();
        },
    },
};
</script>
